import { render, staticRenderFns } from "./masonary-gallery.vue?vue&type=template&id=62f0972a&"
import script from "./masonary-gallery.vue?vue&type=script&lang=js&"
export * from "./masonary-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports